import type {
  ApplePayVerificationRequest,
  ApplePayVerificationResponse,
  ApplePayVerifiedDomainsResponse,
} from '../types';
import type { RequestFn } from '../client';

export class Verification {
  constructor(private readonly request: RequestFn) {}

  async registerApplePayDomains(
    merchantId: string,
    params: ApplePayVerificationRequest,
  ): Promise<ApplePayVerificationResponse> {
    return this.request('POST', `/verify/apple-pay/${encodeURIComponent(merchantId)}`, {
      body: params,
    });
  }

  async getApplePayVerifiedDomains(
    params: Record<string, string>,
  ): Promise<ApplePayVerifiedDomainsResponse> {
    return this.request('GET', '/verify/applepay-verified-domains', {
      query: params,
    });
  }
}
